import { luscinia } from "../luscinia";
import { isRecordPage } from '../Utils/isRecordPage';

export default function reloadBootgrids() {
    if($(`.${luscinia.css.bootgrid}`).length != 0){
        if (isRecordPage()) {
        ($(`.tab-pane.active .${luscinia.css.bootgrid}`) as any).bootgrid("reload");
        }
        else {
            //Refreshes the top bootgrid
            ($(`.${luscinia.css.bootgrid}[data-luscinia-filtercolumnname=""]`) as any).bootgrid("reload");
        }
    }
}